module.exports = __webpack_public_path__ + "media/bootstrap-icons/upc-scan-d6b56d1a.svg";